module.exports = __webpack_public_path__ + "static/img/产品中心-Coalclaw 煤矿私有化智能助手-智能任务督办.4481ffb2.jpg";